module.exports = __webpack_public_path__ + "img/banner2.59b6c478.jpg";